import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useSessionStorage } from 'usehooks-ts';

export default function useSelectedDate(): [Date, (date: Date) => void] {
  const now = dayjs(dayjs().format('YYYY-MM-DD')).toISOString();
  const [dateString, setDateString] = useSessionStorage(
    'activityPlanningSelectedDate',
    now
  );

  const setDate = useCallback(
    (date: Date) => setDateString(date.toISOString()),
    [dateString]
  );
  return [dayjs(dateString).toDate(), setDate];
}
